import { render, staticRenderFns } from "./SliderMelhorDesconto.vue?vue&type=template&id=376ede85&scoped=true&"
import script from "./SliderMelhorDesconto.vue?vue&type=script&lang=js&"
export * from "./SliderMelhorDesconto.vue?vue&type=script&lang=js&"
import style0 from "./SliderMelhorDesconto.vue?vue&type=style&index=0&id=376ede85&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376ede85",
  null
  
)

export default component.exports